<template>
  <div class="wrapper" :style="{marginRight: ismr ? '20px' : '0'}">
    <div class="img" :style="{width:list.length > 1 ? '25%': '35%'}">
      <img :src="imgurl" />
    </div>
    <div class="content-wrapper">
      <div v-for="(item,idex) in list" :key="idex" class="content">
        <div class="content-text">
          <div class="title">{{item.name}}</div>
          <div class="num">{{item.value}}<span class="unit">{{ unit }}</span></div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default{
  props: {
    item: {
      type: Object
    },
    ismr: {
      type: Boolean,
      default: false
    },
    index: {
      type: Number
    }
  },
  data () {
    return {

    }
  },
  computed: {
    list () {
      return this.item.list
    },
    unit () {
      const obj = {
        0: '人',
        1: '人',
        2: '单',
        3: '次',
        4: '人'
      }
      return obj[this.index]
    },
    imgurl () {
      const obj = {
        0: require('@/assets/img/hy1.png'),
        1: require('@/assets/img/hy3.png'),
        2: require('@/assets/img/hs1.png'),
        3: require('@/assets/img/hd1.png'),
        4: require('@/assets/img/rc.png')
      }
      return obj[this.index]
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper{
  width: 100%;
  height: 100%;
  border-radius: 5px;
  padding: 20px 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  background-color: rgba(240,240,240,0.3);
  .img{
    height:100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .content-wrapper{
    flex:1;
    display: flex;
    .content{
      display: flex;
      .content-text{
        flex:1;
        display: flex;
        flex-direction: column;
        .title{
          font-family: MiSans;
          font-weight: 400;
          font-size: 16px;
          color: #464C5E;
          height:47%;
          box-sizing: border-box;
          display: flex;
          align-items: center;
        }
        .num{
          font-family: Acumin Variable Concept;
          font-weight: 600;
          font-size: 36px;
          color: #464C5E;
          height:53%;
          box-sizing: border-box;
        }
        .unit{
          font-family: MiSans;
          font-weight: 400;
          font-size: 14px;
          color: #A2A2A2;
          padding-left: 10px;
        }
      }
    }
  }

}

</style>